// extracted by mini-css-extract-plugin
export default {"switchTypeBtn":"Negotiations_switchTypeBtn__ztSWW","loop":"Negotiations_loop__3878p"};